import { StyleSheet } from "@react-pdf/renderer";
import { qoriaColours } from "@/theme/colours";

const styles = StyleSheet.create({
	main: {
		padding: "28px 32px",
		fontFamily: "Roboto",
	},
	header: {
		flexDirection: "row",
		marginBottom: "10px",
	},
	title: {
		fontSize: 16,
		marginBottom: "4px",
	},
	headerLogo: {
		marginRight: "32px",
		marginLeft: "auto",
		width: "36px",
		height: "36px",
	},
	headerLogoSmoothwall: {
		marginRight: "32px",
		marginLeft: "auto",
		width: "92px",
		height: "28px",
	},
	screenshot: {
		objectFit: "contain",
	},
	imageContainer: {
		height: "82%",
		width: "100%",
		justifyContent: "center",
		backgroundColor: "#d2d2d2",
		marginBottom: "12px",
	},
	footer: {
		fontSize: "14px",
		flexDirection: "row",
		marginBottom: "16px",
	},
	deviceDetails: {
		padding: "6px",
		flexDirection: "row",
		flexWrap: "wrap",
		maxWidth: "540px",
		height: "36px",
		border: "1px",
		borderRadius: "4px",
		borderColor: "#979B9E",
		fontSize: 12,
	},
	deviceDetailItem: {
		minWidth: "160px",
		marginBottom: "2px",
		marginRight: "8px",
	},
	deviceDetailItemText: {
		fontSize: "8px",
	},
	footerRight: {
		marginLeft: "auto",
		textAlign: "right",
		fontSize: 10,
	},
	timestamp: {
		fontFamily: "Roboto",
		marginLeft: "auto",
		fontWeight: "bold",
	},
	pageNum: {
		marginLeft: "auto",
	},
	linkStyle: {
		fontSize: 11,
		width: "680px",
		height: "15px",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		color: qoriaColours.brand.primary[600],
	},
});

export default styles;
